import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Modal,
  Select,
  Button,
  Dropdown,
  Spin,
  Col,
  Input,
  Switch,
  Strong,
  Typography,
  Form,
} from 'antd';
import {
  updateVaccinationDetails,
  getPartners,
  birthCriteria,
  searchCategories,
} from '../../services/api/cashless-vaccination';
const { Option } = Select;

class EditModal extends Component {
  constructor(props) {
    super(props);
    console.log(props, 'props');
    this.state = {
      modalVisible: false,
      loading: false,
      categoryId: this.props.editdata.categoryId || null,
      fetchingCategory: false,
      categoryOptions: [],
      fetchingVaccine: false,
      vaccineOptions: [],
      vaccineAmount: this.props.editdata.vaccineCost || '',
      vaccineName: this.props.editdata.vaccineName || '',
      active: this.props.editdata.activeStatus === 'Active' ? 1 : 0,
      availableAfterDays: this.props.editdata.availableAfterDays || '',
      partnerOptions: [],
      partnerId: this.props.editdata.partnerId || null,
      isChild: this.props.editdata.childVaccine === 1 ? true : false,
      ageLimitDetails: null,
      criteriaTextId: this.props.editdata.ageLimitId || null,
      partnerIdToNameMap: {},
      categoryIdToNameMap: {},
      gender: this.props.editdata.genderCategory || null,
      baseVaccinePrice: this.props.editdata.baseVaccinePrice || null,
      partnerDiscountPrice: this.props.editdata.partnerDiscountPrice || null,
      inoculationCharge: this.props.editdata.inoculationCharge || null,
    };
  }

  componentDidMount() {
    this.getAllPartners();
    this.searchCategory(' ');
    if (this.state.isChild) {
      this.getChildrenAgeDisclaimers();
    }
  }

  searchCategory = (value) => {
    this.setState({ fetchingCategory: true });
    searchCategories(value)
      .then((response) => {
        const categoryOptions = response.body.data.map((ele) => ({
          key: ele.id,
          label: ele.name,
        }));

        const categoryIdToNameMap = response.body.data.reduce((map, ele) => {
          map[ele.id] = ele.name;
          return map;
        }, {});

        this.setState({
          categoryOptions,
          categoryIdToNameMap,
          fetchingCategory: false,
        });
      })
      .catch((err) => {
        console.log({ error: err }, '[searchCategory][error]');
      });
  };

  handleOk = () => {
    this.setState({
      modalVisible: false,
    });
  };
  handleCancel = () => {
    this.props.modalIsOpen = false;
  };

  updateDetails = () => {
    this.setState({ loading: true });
    const body = {
      cost: this.state.vaccineAmount,
      status: this.state.active,
      networkCenterId: this.props.centerId,
      subCategoryId: this.props.editdata.subId,
      availableAfterDays: this.state.availableAfterDays,
      categoryId: this.state.categoryId,
      partnerId: this.state.partnerId,
      isChild: this.state.isChild,
      criteriaTextId: this.state.criteriaTextId,
      gender: this.state.gender,
      baseVaccinePrice: this.state.baseVaccinePrice,
      partnerDiscountPrice: this.state.partnerDiscountPrice,
      inoculationCharge: this.state.inoculationCharge,
    };
    console.log(body, 'body');
    updateVaccinationDetails(body)
      .then((res) => {
        console.log(res, 'res');
        this.setState({ loading: false });
        if (res.body.message === 'success') {
          this.props.handleClose();
          this.props.reload();
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  };

  getAllPartners = () => {
    getPartners()
      .then((response) => {
        console.log({ response }, '[getPartners][response]');
        const partnerOptions = response.body.data.map((ele) => ({
          key: ele.networkPartnerId,
          label: ele.networkPartnerName,
        }));
        const partnerIdToNameMap = response.body.data.reduce((map, ele) => {
          map[ele.networkPartnerId] = ele.networkPartnerName;
          return map;
        }, {});
        this.setState(
          {
            partnerOptions,
            partnerIdToNameMap,
          }
          // () => {
          //   return partnerOptions;
          // }
        );
      })
      .catch((err) => {
        console.log({ error: err }, '[getAllPartners][error]');
      });
  };

  getChildrenAgeDisclaimers = () => {
    return birthCriteria().then((response) => {
      if (response.body.message === 'success') {
        this.setState({
          ageLimitDetails: response.body.data,
        });
      }
    });
  };

  handleCriteriaChange = (event) => {
    this.setState(
      {
        isChild: event,
      },
      () => {
        if (this.state.isChild) {
          this.getChildrenAgeDisclaimers();
        }
      }
    );
  };

  render() {
    const {
      categoryId,
      vaccineOptions,
      categoryOptions,
      vaccineAmount,
      vaccineName,
      availableAfterDays,
      active,
      baseVaccinePrice,
      partnerDiscountPrice,
      gender,
      inoculationCharge,
      loading,
    } = this.state;

    console.log(
      {
        K: this.state.categoryIdToNameMap,
        L: this.state.partnerIdToNameMap,
        categoryId,
      },
      '[state]'
    );
    return (
      <Modal
        visible={this.props.modalIsOpen}
        title="Edit Vaccine"
        // onOk={this.handleOk}
        onCancel={() => {
          this.props.handleClose();
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              this.props.handleClose();
            }}
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={this.updateDetails}
          >
            Submit
          </Button>,
        ]}
      >
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          autoComplete="off"
        >
          <Form.Item label="Select Partner" name="partnerSelect">
            <Select
              showSearch
              style={{ width: '50%', marginLeft: '10px' }}
              dropdownMatchSelectWidth={false}
              notFoundContent={
                this.state.partnerOptions ? <Spin size="small" /> : null
              }
              placeholder="Search Partner"
              defaultActiveFirstOption={true}
              filterOption={false}
              showArrow={false}
              // onSearch={this.searchCategory}
              value={this.state.partnerId}
              onSelect={(value) => {
                this.setState({ partnerId: value });
              }}
            >
              {this.state.partnerOptions.map((ele) => {
                return (
                  <Select.Option key={ele.key} value={ele.key}>
                    {ele.label}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item label="Age Birth Criteria" name="age">
            <Select
              style={{
                width: '50%',
                marginLeft: '10px',
                marginRight: '10px',
              }}
              onChange={this.handleCriteriaChange}
              value={this.state.isChild}
            >
              <Option value={null}>Select an option</Option>
              <Option value={true}>Child</Option>
              <Option value={false}>Adult</Option>
            </Select>
          </Form.Item>
          <Form.Item label="Gender" name="gender">
            <Select
              style={{
                width: '50%',
                marginLeft: '10px',
                marginRight: '10px',
              }}
              placeholder="Select Gender"
              value={gender}
              onChange={(value) => {
                this.setState({ gender: value });
              }}
            >
              <Option value="Male">Male</Option>
              <Option value="Female">Female</Option>
              <Option value="Both">Both</Option>
            </Select>
          </Form.Item>
          {this.state.isChild && this.state.ageLimitDetails && (
            <Form.Item label="Birth Criteria">
              <Select
                showSearch
                style={{ width: '50%', marginLeft: '10px' }}
                dropdownMatchSelectWidth={false}
                notFoundContent={
                  this.state.ageLimitDetails ? <Spin size="small" /> : null
                }
                placeholder="Search Category"
                defaultActiveFirstOption={true}
                filterOption={false}
                showArrow={false}
                // onSearch={this.searchCategory}
                value={this.state.criteriaTextId}
                onSelect={(value) => {
                  console.log({ value }, '[value]');
                  this.setState({ criteriaTextId: value });
                }}
              >
                {this.state.ageLimitDetails.map((ele) => (
                  <Select.Option key={ele.id} value={ele.id}>
                    <Col>{ele.ageTitle}</Col>
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}
          <Form.Item label="Category type:">
            <Select
              showSearch
              style={{ width: '50%', marginLeft: '10px' }}
              dropdownMatchSelectWidth={false}
              notFoundContent={
                this.state.fetchingCategory ? <Spin size="small" /> : null
              }
              placeholder="Search Category"
              defaultActiveFirstOption={true}
              filterOption={false}
              showArrow={false}
              onSearch={this.searchCategory}
              value={this.state.categoryId}
              onSelect={(value) => {
                this.setState({ categoryId: value });
              }}
            >
              {this.state.categoryOptions.map((ele) => (
                <Select.Option key={ele.key} value={ele.key}>
                  {ele.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Vaccine Name:">
            <Input
              style={{ width: '50%', marginLeft: '10px' }}
              value={vaccineName}
              disabled={true}
            />
          </Form.Item>
          <Form.Item label="Sponsor Vaccine Cost:">
            <Input
              style={{ width: '50%', marginLeft: '10px' }}
              value={vaccineAmount}
              onChange={(e) => {
                this.setState({ vaccineAmount: e.target.value });
              }}
            />
          </Form.Item>
          <Form.Item label="Base Price(MRP:">
            <Input
              style={{ width: '50%', marginLeft: '10px' }}
              value={baseVaccinePrice}
              onChange={(e) => {
                this.setState({ baseVaccinePrice: e.target.value });
              }}
            />
          </Form.Item>
          <Form.Item label="Partner Discount Price:">
            <Input
              style={{ width: '50%', marginLeft: '10px' }}
              value={partnerDiscountPrice}
              onChange={(e) => {
                this.setState({ partnerDiscountPrice: e.target.value });
              }}
            />
          </Form.Item>
          <Form.Item label="Inoculation Charges:">
            <Input
              style={{ width: '50%', marginLeft: '10px' }}
              value={inoculationCharge}
              onChange={(e) => {
                this.setState({ inoculationCharge: e.target.value });
              }}
            />
          </Form.Item>
          <Form.Item label="Availability After Days">
            <Input
              style={{ width: '50%', marginLeft: '10px' }}
              value={availableAfterDays}
              onChange={(e) => {
                this.setState({
                  availableAfterDays: e.target.value,
                });
              }}
            />
          </Form.Item>
          <Form.Item label="Status :">
            <Switch
              style={{ marginLeft: '10px' }}
              checked={active}
              onChange={() => {
                this.setState({ active: !active });
              }}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default EditModal;
